import { InjectionToken, Injectable, ɵɵdefineInjectable, EventEmitter, Component, Input, Output, Inject, ɵɵinject, NgModule } from '@angular/core';
import { DatePipe, CommonModule } from '@angular/common';
import { createAction, props, createSelector, createReducer, on, select, Store, StoreModule } from '@ngrx/store';
import { skip, mergeMap, retry, tap, map, catchError, take, filter } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { createEffect, ofType, Actions, EffectsModule } from '@ngrx/effects';
import { of, EMPTY } from 'rxjs';
import Debug from 'debug';
import { InjectedTextFeautureModule, NamedString, InjectedTextProvider } from '@modeso/modeso-lib-core-fe';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/cart.config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ModesoCartConfig() { }
if (false) {
    /** @type {?} */
    ModesoCartConfig.prototype.serviceId;
}
/** @type {?} */
const ModesoCartConfigService = new InjectionToken('Config');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/cart-product.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CartProductModel {
    /**
     * @param {?=} init
     */
    constructor(init) { }
}
if (false) {
    /** @type {?} */
    CartProductModel.prototype._id;
    /** @type {?} */
    CartProductModel.prototype.productId;
    /** @type {?} */
    CartProductModel.prototype.ean;
    /** @type {?} */
    CartProductModel.prototype.title;
    /** @type {?} */
    CartProductModel.prototype.image;
    /** @type {?} */
    CartProductModel.prototype.description;
    /** @type {?} */
    CartProductModel.prototype.price;
    /** @type {?} */
    CartProductModel.prototype.amount;
    /** @type {?} */
    CartProductModel.prototype.packagePrice;
    /** @type {?} */
    CartProductModel.prototype.variablePrice;
    /** @type {?} */
    CartProductModel.prototype.isPackagingSelected;
    /** @type {?} */
    CartProductModel.prototype.category;
    /** @type {?} */
    CartProductModel.prototype.pdfTemplatePath;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/actions/cart.actions.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const addToCart = createAction('[Home Page and Product Page] addToCart', props());
/** @type {?} */
const onAddToCartSuccess = createAction('[Add to cart success response] onAddToCartSuccess', props());
/** @type {?} */
const onAddToCartFail = createAction('[Add to cart fail response] onAddToCartFail', props());
/** @type {?} */
const onChangeProductPackage = createAction('[change product package] onChangeProductPackage', props());
/** @type {?} */
const onRemoveProduct = createAction('[ remove product from cart ] onRemoveProduct', props());
/** @type {?} */
const onRemoveProductSuccess = createAction('[ remove product from cart success response] onRemoveProductSuccess', props());
/** @type {?} */
const onChangeProductPackageSuccess = createAction('[change product package] onChangeProductPackage Success', props());
/** @type {?} */
const onChangeProductAmount = createAction('[change product Amount] onChangeProductAmount', props());
/** @type {?} */
const onChangeProductAmountSuccess = createAction('[change product Amount success response] onChangeProductAmount Success', props());
/** @type {?} */
const onChangeProductAmountFail = createAction('[change product Amount fail response] onChangeProductAmount Fail');
/** @type {?} */
const onLoadCart = createAction('[Cart Page init] get cart data');
/** @type {?} */
const onLoadCartSuccess = createAction('[Cart Page data loaded successfully] get cart data details successfully', props());
/** @type {?} */
const onChangeCardDeliveryOptions = createAction('[cart delivery option] cart data delivery options success', props());
/** @type {?} */
const addNewCart = createAction('[Home Page and Product Page] addNewCart');
/** @type {?} */
const onNewToCartSuccess = createAction('[Add new cart success response] onNewToCartSuccess', props());
/** @type {?} */
const addSelectedDeliveryOption = createAction('[Cart] addSelectedDeliveryOption', props());
/** @type {?} */
const onAddSelectedDeliveryOptionSuccessfully = createAction('[Cart] addSelectedDeliveryOption successfully', props());
/** @type {?} */
const onAddSelectedDeliveryOptionFailed = createAction('[Cart] addSelectedDeliveryOption failed', props());
/**
 * @record
 * @template T
 */
function IActionWithPayload() { }
if (false) {
    /** @type {?} */
    IActionWithPayload.prototype.payload;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/response/cart-response.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CartResponseModel {
    /**
     * @param {?=} init
     */
    constructor(init) { }
}
if (false) {
    /** @type {?} */
    CartResponseModel.prototype.cart;
    /** @type {?} */
    CartResponseModel.prototype.totalPrice;
    /** @type {?} */
    CartResponseModel.prototype.message;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/delivery-options.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// TODO: this must exist, but with only the display options, and the options that the cart can calculate everything
class DeliveryOptionModel {
    /**
     * @param {?} key key of delivery option
     * @param {?} name name of delivery option
     * @param {?} description description of delivery option (time to deliver)
     * @param {?} price price of delivery option
     * @param {?} currency currency of delivery option
     * @param {?} vatTaxRate rate of tax (e.g. 7.7 it mean 7.7%)
     * @param {?} _id id of the delivery option
     * @param {?} selected
     */
    constructor(key, name, description, price, currency, vatTaxRate, _id, selected) {
        this.key = key;
        this.name = name;
        this.description = description;
        this.price = price;
        this.currency = currency;
        this.vatTaxRate = vatTaxRate;
        this._id = _id;
        this.selected = selected;
    }
}
if (false) {
    /** @type {?} */
    DeliveryOptionModel.prototype.key;
    /** @type {?} */
    DeliveryOptionModel.prototype.name;
    /** @type {?} */
    DeliveryOptionModel.prototype.description;
    /** @type {?} */
    DeliveryOptionModel.prototype.price;
    /** @type {?} */
    DeliveryOptionModel.prototype.currency;
    /** @type {?} */
    DeliveryOptionModel.prototype.vatTaxRate;
    /** @type {?} */
    DeliveryOptionModel.prototype._id;
    /** @type {?} */
    DeliveryOptionModel.prototype.selected;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/reducers/cart.reducer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const cartFeatureKey = 'modesoCartMicroservice';
/**
 * @record
 */
function FeatureState() { }
if (false) {
    /** @type {?} */
    FeatureState.prototype.cart;
    /** @type {?} */
    FeatureState.prototype.product;
    /** @type {?} */
    FeatureState.prototype.deliveryOption;
    /** @type {?} */
    FeatureState.prototype.status;
}
/**
 * @record
 */
function AppState() { }
if (false) {
    /** @type {?} */
    AppState.prototype.modesoCartMicroservice;
}
// State Declarations - END
// Selectors Declarations - START
/** @type {?} */
const selectFeature = (/**
 * @param {?} state
 * @return {?}
 */
(state) => state.modesoCartMicroservice);
const ɵ0 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state.cart;
/** @type {?} */
const featureCart = createSelector(selectFeature, (ɵ0));
const ɵ1 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state.cart.cart.deliveryOptions;
/** @type {?} */
const featureDeliveryOptionsOfCart = createSelector(selectFeature, (ɵ1));
const ɵ2 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state.deliveryOption;
/** @type {?} */
const featureDeliveryOption = createSelector(selectFeature, (ɵ2));
const ɵ3 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state.status;
/** @type {?} */
const featureStatusOfOperationsOnCart = createSelector(selectFeature, (ɵ3));
// Selectors Declarations - END
// Reducer Declarations - START
/** @type {?} */
const initialState = {
    product: new CartProductModel(),
    cart: new CartResponseModel(),
    deliveryOption: new DeliveryOptionModel('', '', '', 0, '', 0, '', false),
    status: undefined
};
const ɵ4 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { product: action.payload })), ɵ5 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { cart: action.payload, status: '' })), ɵ6 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { cart: action.payload, status: 'addToCartFaild' })), ɵ7 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (Object.assign({}, state)), ɵ8 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { cart: action.payload })), ɵ9 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (Object.assign({}, state)), ɵ10 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { cart: action.payload, status: '' })), ɵ11 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (Object.assign({}, state, { status: 'changeProductAmountFaild' })), ɵ12 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (Object.assign({}, state)), ɵ13 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { cart: action.payload })), ɵ14 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (Object.assign({}, state)), ɵ15 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { cart: action.payload })), ɵ16 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { deliveryOption: action.payload })), ɵ17 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (Object.assign({}, state)), ɵ18 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { cart: action.payload })), ɵ19 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (Object.assign({}, state)), ɵ20 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => (Object.assign({}, state, { deliveryOption: action.payload })), ɵ21 = /**
 * @param {?} state
 * @return {?}
 */
(state) => (Object.assign({}, state));
/** @type {?} */
const cartReducer = createReducer(initialState, on(addToCart, (ɵ4)), on(onAddToCartSuccess, (ɵ5)), on(onAddToCartFail, (ɵ6)), on(onChangeProductPackage, (ɵ7)), on(onChangeProductPackageSuccess, (ɵ8)), on(onChangeProductAmount, (ɵ9)), on(onChangeProductAmountSuccess, (ɵ10)), on(onChangeProductAmountFail, (ɵ11)), on(onLoadCart, (ɵ12)), on(onLoadCartSuccess, (ɵ13)), on(onRemoveProduct, (ɵ14)), on(onRemoveProductSuccess, (ɵ15)), on(onChangeCardDeliveryOptions, (ɵ16)), on(addNewCart, (ɵ17)), on(onNewToCartSuccess, (ɵ18)), on(addSelectedDeliveryOption, (ɵ19)), on(onAddSelectedDeliveryOptionSuccessfully, (ɵ20)), on(onAddSelectedDeliveryOptionFailed, (ɵ21)));
/**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
function reducer(state, action) {
    return cartReducer(state, action);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/cartLocalStorageService.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CartLocalStorageService {
    constructor() { }
    /**
     * set current cart to localStorage.
     * @param {?} cartId
     * @return {?}
     */
    setCartId(cartId) {
        this.getLocalStorage().setItem(CartLocalStorageService.cartIdKey, cartId);
    }
    /**
     * check if current cartId is saved in localStorage.
     * @return {?}
     */
    isSetCartId() {
        /** @type {?} */
        const cartId = this.getLocalStorage().getItem(CartLocalStorageService.cartIdKey);
        return cartId ? true : false;
    }
    /**
     * return cart id.
     * @return {?}
     */
    getCartId() {
        /** @type {?} */
        const cartId = this.getLocalStorage().getItem(CartLocalStorageService.cartIdKey);
        return cartId;
    }
    /**
     * delete cart id.
     * @return {?}
     */
    deleteCartId() {
        this.getLocalStorage().removeItem(CartLocalStorageService.cartIdKey);
        CartLocalStorageService.cartDeletedEvent.next(true);
    }
    /**
     * return local storage.
     * @return {?}
     */
    getLocalStorage() {
        return localStorage;
    }
}
CartLocalStorageService.cartIdKey = 'cartId';
CartLocalStorageService.cartDeletedEvent = new BehaviorSubject(false);
CartLocalStorageService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */
CartLocalStorageService.ctorParameters = () => [];
/** @nocollapse */ CartLocalStorageService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CartLocalStorageService_Factory() { return new CartLocalStorageService(); }, token: CartLocalStorageService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    CartLocalStorageService.cartIdKey;
    /** @type {?} */
    CartLocalStorageService.cartDeletedEvent;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/add-to-cart/add-to-cart.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AddToCartComponent {
    /**
     * @param {?} store
     * @param {?} cartLocalStorageService
     */
    constructor(store, cartLocalStorageService) {
        this.store = store;
        this.cartLocalStorageService = cartLocalStorageService;
        this.productNotificationEvent = new EventEmitter();
        this.addToCartState$ = this.store.pipe(select(featureCart));
        this.isProductCard = false;
        this.price = 0;
    }
    /**
     * @return {?}
     */
    get product() {
        return this._product;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set product(value) {
        this._product = value;
        this.productDetails = value;
        if (value !== undefined) {
            this.productId = value.productId;
            this.title = value.title;
            this.image = value.image;
            this.description = value.description;
            this.packagePrice = value.packagePrice;
            this.variablePrice = value.variablePrice;
            this.isFixed = value.price ? true : false;
            this.category = value.category;
            this.ean = value.ean;
            this.pdfTemplatePath = value.pdfTemplatePath;
            if (!this.isProductCard) {
                this.price = value.price ? value.price : value.variablePrice.defaultPrice;
            }
            this.isProductCard = true;
        }
        else {
            this.productId = undefined;
            this.title = undefined;
            this.image = undefined;
            this.description = undefined;
            this.price = undefined;
            this.packagePrice = undefined;
            this.category = undefined;
            this.ean = undefined;
            this.pdfTemplatePath = undefined;
        }
    }
    /**
     * @return {?}
     */
    addToCart() {
        if (!this.isPriceWithinRange()) {
            this.productNotificationEvent.emit({
                message: 'modeso_cart_add-to-cart_price_error',
                isError: true,
                productId: this.productId
            });
        }
        else if (!this.isValidAmount()) {
            this.productNotificationEvent.emit({
                message: 'modeso_cart_add-to-cart_amount_error',
                isError: true,
                productId: this.productId
            });
        }
        else {
            if (!this.cartLocalStorageService.isSetCartId()) {
                this.store.dispatch(addNewCart());
            }
            else {
                this.dispatchAddToCartAction();
                this.checkAddToCartSuccessfully();
                setTimeout((/**
                 * @return {?}
                 */
                () => {
                    this.gtagAddToCart();
                }), 1000);
            }
        }
    }
    /**
     * @private
     * @return {?}
     */
    isValidAmount() {
        return this.amount >= 1;
    }
    /**
     * @private
     * @return {?}
     */
    isPriceWithinRange() {
        if ((this.price < this.variablePrice.from) || (this.price > this.variablePrice.to)) {
            return false;
        }
        return true;
    }
    /**
     * @return {?}
     */
    dispatchAddToCartAction() {
        /** @type {?} */
        const data = { payload: this.createActionPayload() };
        this.store.dispatch(addToCart(data));
    }
    /**
     * @private
     * @return {?}
     */
    createActionPayload() {
        const { title, price, productId, amount, description, image, variablePrice, packagePrice, category, ean, pdfTemplatePath } = this;
        return { title, price, productId, amount: +amount, description, image, variablePrice, packagePrice: +packagePrice, category, ean, pdfTemplatePath };
    }
    /**
     * @return {?}
     */
    changeVariablePrice() {
        this.fireDataChangedEvent();
    }
    /**
     * @return {?}
     */
    changeAmount() {
        this.fireDataChangedEvent();
    }
    /**
     * @return {?}
     */
    fireDataChangedEvent() {
        this.productNotificationEvent.emit(undefined);
    }
    /**
     * @return {?}
     */
    checkAddToCartSuccessfully() {
        this.addToCartState$.pipe(skip(1)).subscribe((/**
         * @param {?} status
         * @return {?}
         */
        (status) => {
            if (status.error) {
                this.productNotificationEvent.emit({
                    message: 'modeso_cart_add-to-cart_total_exceeded_error',
                    isError: true,
                    productId: this.productId
                });
            }
            else {
                this.productNotificationEvent.emit({
                    message: 'modeso_cart_added-to-cart_title',
                    isError: false,
                    productId: this.productId
                });
            }
        }));
    }
    /**
     * @return {?}
     */
    gtagAddToCart() {
        //gtag('event', 'conversion', {'send_to': 'AW-10789076290/36mFCMitqoADEML60Jgo'});
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            'event': 'EECaddToCart',
            'ecommerce': {
                'add': {
                    'products': [{
                            'name': this.title,
                            'id': this.productId,
                            'price': this.price,
                            'category': this.category,
                            'quantity': this.amount,
                        }]
                }
            }
        });
    }
}
AddToCartComponent.decorators = [
    { type: Component, args: [{
                selector: 'lidl-lib-cart-fe-add-to-cart',
                template: "<div class=\"lidl-lib-cart-fe-add-to-cart input-group\">\n    <div class=\"lidl-lib-cart-fe-add-to-cart__actions\" [ngClass]=\"{'variable-price': !isFixed}\">\n        <div>\n            <div class=\"lidl-lib-cart-fe-add-to-cart__actions__inputs\">\n                <label>{{ \"modeso_cart_add-to-cart-amount_caption\" | injectedText | async }}</label>\n                <input maxlength=\"3\" [ngModel]=\"amount\" (ngModelChange)=\"amount = $event; changeAmount()\"\n                    onkeypress=\"return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57\">\n               \n            </div>\n            <div class=\"lidl-lib-cart-fe-add-to-cart__actions__inputs\" *ngIf=\"!isFixed\">\n                <label>{{ \"modeso_cart_add-to-cart-price_caption\" | injectedText | async }}</label>\n                <input maxlength=\"4\" id=\"variable-price\" [ngModel]=\"price\" (ngModelChange)=\"price = $event; changeVariablePrice()\"\n                    onkeypress=\"return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57\">\n            </div>\n        </div>\n        <button class=\"btn-cta\" (click)=\"addToCart()\" id=\"addToCartBtn\">{{caption}} </button>\n    </div>\n    <div class=\"lidl-lib-cart-fe-add-to-cart__fixed-price\" *ngIf=\"isFixed\">\n        <p><small>CHF</small> {{price}}</p>\n    </div>\n</div>",
                styles: [".lidl-lib-cart-fe-add-to-cart{justify-content:space-between;flex-direction:row-reverse;flex-wrap:wrap;width:100%}.lidl-lib-cart-fe-add-to-cart__actions{display:flex;flex-wrap:wrap;gap:1em}.lidl-lib-cart-fe-add-to-cart__actions__inputs{display:flex;flex-direction:column}.lidl-lib-cart-fe-add-to-cart__actions__inputs:nth-child(2){margin-right:2rem}.lidl-lib-cart-fe-add-to-cart__actions__inputs:nth-child(2) input{width:4rem}.lidl-lib-cart-fe-add-to-cart__actions.variable-price{width:100%;justify-content:space-between}.lidl-lib-cart-fe-add-to-cart__actions.variable-price>div{display:flex;flex-direction:row-reverse;justify-content:flex-end}.lidl-lib-cart-fe-add-to-cart__fixed-price{display:flex;justify-content:flex-end;align-items:flex-end}.lidl-lib-cart-fe-add-to-cart__fixed-price p{margin:0;font-size:30px;font-weight:700}.lidl-lib-cart-fe-add-to-cart__fixed-price small{font-size:14px}.lidl-lib-cart-fe-add-to-cart input{border:1px solid #d3d3d3;width:3rem;height:45px;line-height:45px}.lidl-lib-cart-fe-add-to-cart label{font-weight:700}.lidl-lib-cart-fe-add-to-cart button{align-self:flex-end;min-height:45px}.lidl-lib-cart-fe-add-to-cart #variable-price-error{color:red}"]
            }] }
];
/** @nocollapse */
AddToCartComponent.ctorParameters = () => [
    { type: Store },
    { type: CartLocalStorageService }
];
AddToCartComponent.propDecorators = {
    caption: [{ type: Input }],
    productNotificationEvent: [{ type: Output }],
    product: [{ type: Input, args: ['product',] }]
};
if (false) {
    /** @type {?} */
    AddToCartComponent.prototype.caption;
    /** @type {?} */
    AddToCartComponent.prototype.productNotificationEvent;
    /** @type {?} */
    AddToCartComponent.prototype.addToCartState$;
    /** @type {?} */
    AddToCartComponent.prototype._product;
    /** @type {?} */
    AddToCartComponent.prototype.isFixed;
    /** @type {?} */
    AddToCartComponent.prototype.isProductCard;
    /** @type {?} */
    AddToCartComponent.prototype.productDetails;
    /**
     * @type {?}
     * @private
     */
    AddToCartComponent.prototype.productId;
    /**
     * @type {?}
     * @private
     */
    AddToCartComponent.prototype.title;
    /**
     * @type {?}
     * @private
     */
    AddToCartComponent.prototype.image;
    /**
     * @type {?}
     * @private
     */
    AddToCartComponent.prototype.description;
    /** @type {?} */
    AddToCartComponent.prototype.price;
    /**
     * @type {?}
     * @private
     */
    AddToCartComponent.prototype.packagePrice;
    /** @type {?} */
    AddToCartComponent.prototype.variablePrice;
    /** @type {?} */
    AddToCartComponent.prototype.category;
    /** @type {?} */
    AddToCartComponent.prototype.amount;
    /** @type {?} */
    AddToCartComponent.prototype.ean;
    /** @type {?} */
    AddToCartComponent.prototype.pdfTemplatePath;
    /** @type {?} */
    AddToCartComponent.prototype.cartProduct$;
    /**
     * @type {?}
     * @private
     */
    AddToCartComponent.prototype.store;
    /**
     * @type {?}
     * @private
     */
    AddToCartComponent.prototype.cartLocalStorageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/cart-icon/cart-icon.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CartIconComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.cartItemsAmount = 0;
    }
}
CartIconComponent.decorators = [
    { type: Component, args: [{
                selector: 'lidl-lib-cart-fe-icon',
                template: "<div class=\"lidl-lib-cart-fe-icon\">\n    <ng-container *ngIf=\"cartItemsAmount > 99; else elseTemplate\">\n        <div class=\"numberCircle\">99+</div>\n    </ng-container>\n    <ng-template #elseTemplate>\n        <div *ngIf=\"cartItemsAmount\" class=\"numberCircle\" id=\"cartNumber\">{{cartItemsAmount}}</div>\n    </ng-template>\n    <svg id=\"icon\" class=\"cart-icon\">\n        <use xlink:href=\"assets/images/sprite_icons.svg#Lidl_giftcard_Icons-svg3\"></use>\n    </svg>\n    <span>\n        <ng-content></ng-content>\n    </span>\n</div>\n",
                styles: [".lidl-lib-cart-fe-icon{display:block;position:relative;height:54px;text-align:center;width:60px;max-width:100px;cursor:pointer}.lidl-lib-cart-fe-icon svg{height:2rem;width:100%;margin-bottom:10px;fill:#00438f}.lidl-lib-cart-fe-icon span{display:block;line-height:1;font-size:14px;letter-spacing:normal}.lidl-lib-cart-fe-icon .numberCircle{position:absolute;top:-1em;right:0;width:1.75em;height:1.75em;border-radius:50%;background:#ef080c;color:#fff;font-size:.75rem;font-weight:700;display:flex;justify-content:center;align-items:center}@media (max-width:992px){.lidl-lib-cart-fe-icon{height:25px;width:30px}.lidl-lib-cart-fe-icon svg{height:25px}.lidl-lib-cart-fe-icon span{display:none}.lidl-lib-cart-fe-icon .numberCircle{font-size:.6rem;top:-.5em;right:-.5em}}"]
            }] }
];
/** @nocollapse */
CartIconComponent.ctorParameters = () => [];
CartIconComponent.propDecorators = {
    src: [{ type: Input }],
    srcset: [{ type: Input }],
    cartItemsAmount: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    CartIconComponent.prototype.src;
    /** @type {?} */
    CartIconComponent.prototype.srcset;
    /** @type {?} */
    CartIconComponent.prototype.cartItemsAmount;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/cart.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CartService {
    // tslint:disable-next-line: whitespace
    /**
     * @param {?} http
     * @param {?} config
     * @param {?} cartLocalStorageService
     */
    constructor(http, config, cartLocalStorageService) {
        this.http = http;
        this.config = config;
        this.cartLocalStorageService = cartLocalStorageService;
        this.server = '';
        this.microserviceName = 'cart';
        this.server = config.apiGateway;
    }
    /**
     * @param {?} product
     * @return {?}
     */
    addToCart(product) {
        /** @type {?} */
        const url = `${this.config.apiGateway}${this.microserviceName}/${this.cartLocalStorageService.getCartId()}`;
        return this.http.post(url, product.payload);
    }
    /**
     * @return {?}
     */
    addNewCart() {
        /** @type {?} */
        const url = `${this.config.apiGateway}${this.microserviceName}/`;
        return this.http.post(url, {});
    }
    /**
     * @param {?} product
     * @return {?}
     */
    updateProductInCart(product) {
        /** @type {?} */
        const url = `${this.config.apiGateway}${this.microserviceName}s/${product.payload.cartId}/${product.payload._id}`;
        return this.http.put(url, product.payload);
    }
    /**
     * @param {?} cartId
     * @return {?}
     */
    getCartById(cartId) {
        /** @type {?} */
        const url = `${this.config.apiGateway}${this.microserviceName}/${cartId}`;
        return this.http.get(url);
    }
    /**
     * @param {?} request
     * @return {?}
     */
    removeProduct(request) {
        /** @type {?} */
        const url = `${this.config.apiGateway}${this.microserviceName}s/${request.payload.cartId}/${request.payload._id}`;
        return this.http.delete(url);
    }
    /**
     * @param {?} addDeliveryOptionToCartRequest
     * @return {?}
     */
    addDeliveryOptionToCart(addDeliveryOptionToCartRequest) {
        /** @type {?} */
        const url = `${this.config.apiGateway}${this.microserviceName}/${this.cartLocalStorageService.getCartId()}`;
        return this.http.put(url, addDeliveryOptionToCartRequest.payload);
    }
}
CartService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
CartService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [ModesoCartConfigService,] }] },
    { type: CartLocalStorageService }
];
/** @nocollapse */ CartService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CartService_Factory() { return new CartService(ɵɵinject(HttpClient), ɵɵinject(ModesoCartConfigService), ɵɵinject(CartLocalStorageService)); }, token: CartService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    CartService.prototype.server;
    /**
     * @type {?}
     * @private
     */
    CartService.prototype.microserviceName;
    /**
     * @type {?}
     * @private
     */
    CartService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    CartService.prototype.config;
    /**
     * @type {?}
     * @private
     */
    CartService.prototype.cartLocalStorageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/effects/cart.effect.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug = Debug('modeso:lidl-lib-cart-fe:CartEffect');
class CartEffect {
    /**
     * @param {?} action$
     * @param {?} cartService
     * @param {?} cartLocalStorageService
     */
    constructor(action$, cartService, cartLocalStorageService) {
        this.action$ = action$;
        this.cartService = cartService;
        this.cartLocalStorageService = cartLocalStorageService;
        this.addToCart$ = createEffect((/**
         * @return {?}
         */
        () => this.action$.pipe(ofType(addToCart.type), mergeMap((/**
         * @param {?} payload
         * @return {?}
         */
        payload => {
            return this.cartService.addToCart(payload)
                .pipe(retry(1), tap((/**
             * @param {?} response
             * @return {?}
             */
            response => {
                this.saveProductIdToSessionStorage();
            })), map((/**
             * @param {?} response
             * @return {?}
             */
            response => (onAddToCartSuccess({ payload: response })))), catchError((/**
             * @param {?} error
             * @return {?}
             */
            (error) => of(onAddToCartFail({ payload: error })))));
        })))));
        this.packageChanged$ = createEffect((/**
         * @return {?}
         */
        () => this.action$.pipe(ofType(onChangeProductPackage.type), mergeMap((/**
         * @param {?} payload
         * @return {?}
         */
        payload => {
            return this.cartService.updateProductInCart(payload)
                .pipe(retry(1), map((/**
             * @param {?} response
             * @return {?}
             */
            response => (onChangeProductPackageSuccess({ payload: response })))), catchError((/**
             * @return {?}
             */
            () => EMPTY)));
        })))));
        this.cartLoaded$ = createEffect((/**
         * @return {?}
         */
        () => this.action$.pipe(ofType(onLoadCart.type), mergeMap((/**
         * @return {?}
         */
        () => {
            return this.cartService.getCartById(this.cartLocalStorageService.getCartId())
                .pipe(retry(1), map((/**
             * @param {?} response
             * @return {?}
             */
            response => (onLoadCartSuccess({ payload: response })))), catchError((/**
             * @return {?}
             */
            () => EMPTY)));
        })))));
        this.removeProduct$ = createEffect((/**
         * @return {?}
         */
        () => this.action$.pipe(ofType(onRemoveProduct.type), mergeMap((/**
         * @param {?} payload
         * @return {?}
         */
        payload => {
            return this.cartService.removeProduct(payload)
                .pipe(retry(1), tap((/**
             * @param {?} response
             * @return {?}
             */
            response => this.saveAddToCartResponseToLocalStorage(response))), map((/**
             * @param {?} response
             * @return {?}
             */
            response => onRemoveProductSuccess({ payload: response }))), catchError((/**
             * @return {?}
             */
            () => EMPTY)));
        })))));
        this.amountChanged$ = createEffect((/**
         * @return {?}
         */
        () => this.action$.pipe(ofType(onChangeProductAmount.type), mergeMap((/**
         * @param {?} payload
         * @return {?}
         */
        payload => {
            return this.cartService.updateProductInCart(payload)
                .pipe(retry(1), map((/**
             * @param {?} response
             * @return {?}
             */
            response => (onChangeProductAmountSuccess({ payload: response })))), catchError((/**
             * @param {?} error
             * @return {?}
             */
            (error) => of(onChangeProductAmountFail()))));
        })))));
        this.addNewCart$ = createEffect((/**
         * @return {?}
         */
        () => this.action$.pipe(ofType(addNewCart.type), mergeMap((/**
         * @param {?} payload
         * @return {?}
         */
        payload => {
            return this.cartService.addNewCart()
                .pipe(take(1), tap((/**
             * @param {?} response
             * @return {?}
             */
            response => {
                this.saveAddToCartResponseToLocalStorage(response);
            })), map((/**
             * @param {?} response
             * @return {?}
             */
            response => onNewToCartSuccess({ payload: response }))), catchError((/**
             * @return {?}
             */
            () => EMPTY)));
        })))));
        this.addDeliveryOptionToCart$ = createEffect((/**
         * @return {?}
         */
        () => this.action$.pipe(ofType(addSelectedDeliveryOption), mergeMap((/**
         * @param {?} payload
         * @return {?}
         */
        payload => {
            return this.cartService.addDeliveryOptionToCart(payload)
                .pipe(map((/**
             * @param {?} response
             * @return {?}
             */
            response => onAddSelectedDeliveryOptionSuccessfully({
                payload: this.getSelectedDeliveryOptionFromCartResponse(response.cart.deliveryOptions)
            }))), catchError((/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                return of(onAddSelectedDeliveryOptionFailed({ payload: error }));
            })));
        })))));
        this.errorOnGetAllLocalization$ = createEffect((/**
         * @return {?}
         */
        () => this.action$.pipe(ofType(onAddSelectedDeliveryOptionFailed.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleOnLoadAllCartErrors(action.payload))))), { dispatch: false });
        this.errorOnAddToCart$ = createEffect((/**
         * @return {?}
         */
        () => this.action$.pipe(ofType(onAddToCartFail.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleOnLoadAllCartErrors(action.payload))))), { dispatch: false });
    }
    /**
     * @private
     * @param {?} error
     * @return {?}
     */
    handleOnLoadAllCartErrors(error) {
        debug(error);
        return error;
    }
    /**
     * @private
     * @param {?} response
     * @return {?}
     */
    saveAddToCartResponseToLocalStorage(response) {
        this.cartLocalStorageService.setCartId(response.cart._id);
    }
    /**
     * @private
     * @return {?}
     */
    saveProductIdToSessionStorage() {
        sessionStorage.setItem('isProductAddedToCart', 'true');
    }
    /**
     * @private
     * @param {?} deliveryOptions
     * @return {?}
     */
    getSelectedDeliveryOptionFromCartResponse(deliveryOptions) {
        /** @type {?} */
        const selectedDeliveryOption = deliveryOptions.find((/**
         * @param {?} deliveryOption
         * @return {?}
         */
        (deliveryOption) => deliveryOption.selected === true));
        return selectedDeliveryOption;
    }
}
CartEffect.decorators = [
    { type: Injectable }
];
/** @nocollapse */
CartEffect.ctorParameters = () => [
    { type: Actions },
    { type: CartService },
    { type: CartLocalStorageService }
];
if (false) {
    /** @type {?} */
    CartEffect.prototype.addToCart$;
    /** @type {?} */
    CartEffect.prototype.packageChanged$;
    /** @type {?} */
    CartEffect.prototype.cartLoaded$;
    /** @type {?} */
    CartEffect.prototype.removeProduct$;
    /** @type {?} */
    CartEffect.prototype.amountChanged$;
    /** @type {?} */
    CartEffect.prototype.addNewCart$;
    /** @type {?} */
    CartEffect.prototype.addDeliveryOptionToCart$;
    /** @type {?} */
    CartEffect.prototype.errorOnGetAllLocalization$;
    /** @type {?} */
    CartEffect.prototype.errorOnAddToCart$;
    /**
     * @type {?}
     * @private
     */
    CartEffect.prototype.action$;
    /**
     * @type {?}
     * @private
     */
    CartEffect.prototype.cartService;
    /**
     * @type {?}
     * @private
     */
    CartEffect.prototype.cartLocalStorageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/request/product-update-request.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductUpdateRequestModel {
    /**
     * @param {?=} init
     */
    constructor(init) { }
}
if (false) {
    /** @type {?} */
    ProductUpdateRequestModel.prototype.productId;
    /** @type {?} */
    ProductUpdateRequestModel.prototype.cartId;
    /** @type {?} */
    ProductUpdateRequestModel.prototype.amount;
    /** @type {?} */
    ProductUpdateRequestModel.prototype.isPackagingSelected;
    /** @type {?} */
    ProductUpdateRequestModel.prototype._id;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/product-package/product-package.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductPackageComponent {
    /**
     * @param {?} store
     * @param {?} cartLocalStorageService
     */
    constructor(store, cartLocalStorageService) {
        this.store = store;
        this.cartLocalStorageService = cartLocalStorageService;
        this.packages = [{ id: 1, name: "Keine Verpackung" }, { id: 2, name: "Geschenkverpackung" }];
    }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * @param {?} packageId
     * @return {?}
     */
    packageChanged(packageId) {
        if (this.product && packageId) {
            this.store.dispatch(onChangeProductPackage({ payload: this.constructProductUpdateRequestModel(packageId) }));
        }
    }
    /**
     * @param {?} packageId
     * @return {?}
     */
    constructProductUpdateRequestModel(packageId) {
        /** @type {?} */
        const changeProductPackage = new ProductUpdateRequestModel();
        changeProductPackage.productId = this.product.productId;
        changeProductPackage.amount = this.product ? this.product.amount : null;
        changeProductPackage.cartId = this.cartLocalStorageService.getCartId();
        changeProductPackage.isPackagingSelected = +packageId === 1 ? false : true;
        return changeProductPackage;
    }
}
ProductPackageComponent.decorators = [
    { type: Component, args: [{
                selector: 'modeso-product-package',
                template: "<div class=\"product-package\">\n  <select (change)=\"packageChanged($event.target.value)\" class=\"classic col-lg-11\" id=\"package\"\n    [value]=\"product.isPackagingSelected ? 2 : 1\">\n    <option *ngFor=\"let package of packages\" [value]=\"package.id\">{{ package.name }}</option>\n  </select>\n</div>\n",
                styles: [".product-package select{background-color:#fff;border-radius:initial;border-color:#919191;padding:10px;margin-bottom:10px;-webkit-appearance:none}.product-package select.classic{background-image:linear-gradient(45deg,transparent 50%,#fff 50%),linear-gradient(135deg,#fff 50%,transparent 50%),linear-gradient(to right,#989898,#989898);background-position:calc(100% - 20px) calc(1em + 2px),calc(100% - 15px) calc(1em + 2px),100% 0;background-size:5px 5px,5px 5px,2.5em 3em;background-repeat:no-repeat;width:191px}.product-package label{display:block}"]
            }] }
];
/** @nocollapse */
ProductPackageComponent.ctorParameters = () => [
    { type: Store },
    { type: CartLocalStorageService }
];
ProductPackageComponent.propDecorators = {
    product: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ProductPackageComponent.prototype.product;
    /** @type {?} */
    ProductPackageComponent.prototype.packages;
    /**
     * @type {?}
     * @private
     */
    ProductPackageComponent.prototype.store;
    /**
     * @type {?}
     * @private
     */
    ProductPackageComponent.prototype.cartLocalStorageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/cart/cart.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CartComponent {
    /**
     * @param {?} store
     * @param {?} cartLocalStorageService
     */
    constructor(store, cartLocalStorageService) {
        this.store = store;
        this.cartLocalStorageService = cartLocalStorageService;
        this.cartIdToCartPAge = new EventEmitter();
        this.cartProductsAmount = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.cartLocalStorageService.isSetCartId()) {
            this.store.dispatch(onLoadCart());
        }
        this.store.pipe(select(featureCart)).subscribe((/**
         * @param {?} cart
         * @return {?}
         */
        cart => {
            this.carts = cart;
            if (cart && cart.cart) {
                this.cartProductsAmount.emit(cart.cart.products);
            }
        }));
    }
    /**
     * @param {?} cartId
     * @return {?}
     */
    emitCurrentCartId(cartId) {
        this.cartIdToCartPAge.emit(cartId);
    }
}
CartComponent.decorators = [
    { type: Component, args: [{
                selector: 'lidl-lib-cart-fe',
                template: "<div class=\"cart-container\">\n  <div class=\"row\">\n    <div class=\"col-lg-12\">\n      <div class=\"page-title\">\n        <!-- TODO move to cart page in shop-->\n        <h1> {{ \"modeso_cart_cart-icon-label\" | injectedText | async }} </h1>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\" id=\"productId\" *ngIf=\"carts.cart\">\n    <div class=\"col-lg-12\" *ngIf=\"carts.cart?.products?.length > 0;else empty_cart\">\n      <lidl-lib-cart-fe-product-list [products]='carts?.cart?.products'\n        (currentCartId)=\"emitCurrentCartId($event)\"></lidl-lib-cart-fe-product-list>\n    </div>\n    <ng-template #empty_cart>\n      <div class=\"col-lg-12 alert alert-danger text-center\" role=\"alert\" id=\"productMessage\">\n        {{ \"modeso_cart_cart_empty\" | injectedText | async }}\n      </div>\n    </ng-template>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-lg-7\"></div>\n    <div class=\"col-lg-5\">\n      <ng-content *ngTemplateOutlet=\"deliveryRef\"></ng-content>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-lg-7\"></div>\n    <div class=\"col-lg-5 action-footer\">\n      <cart-total-option [cartTotalPrice]='carts?.totalPrice' [additionalCharges]='additionalCharges'>\n      </cart-total-option>\n      <ng-content select=\"[afterTotal]\"></ng-content>\n    </div>\n  </div>\n\n</div>\n",
                styles: [".page-title{margin-bottom:20px}.page-title h1{font-size:42px;font-weight:700}@media (max-width:991px){.action-footer{position:fixed;left:0;bottom:0;right:0;background-color:#fff;box-shadow:0 -2px 4px 0 rgba(0,0,0,.15);z-index:9999;padding:1em}}"]
            }] }
];
/** @nocollapse */
CartComponent.ctorParameters = () => [
    { type: Store },
    { type: CartLocalStorageService }
];
CartComponent.propDecorators = {
    additionalCharges: [{ type: Input }],
    cartIdToCartPAge: [{ type: Output }],
    cartProductsAmount: [{ type: Output }],
    deliveryRef: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    CartComponent.prototype.additionalCharges;
    /** @type {?} */
    CartComponent.prototype.carts;
    /** @type {?} */
    CartComponent.prototype.cartIdToCartPAge;
    /** @type {?} */
    CartComponent.prototype.cartProductsAmount;
    /** @type {?} */
    CartComponent.prototype.deliveryRef;
    /**
     * @type {?}
     * @private
     */
    CartComponent.prototype.store;
    /**
     * @type {?}
     * @private
     */
    CartComponent.prototype.cartLocalStorageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/request/product-remove-request.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductRemoveRequestModel {
    /**
     * @param {?=} init
     */
    constructor(init) { }
}
if (false) {
    /** @type {?} */
    ProductRemoveRequestModel.prototype.productId;
    /** @type {?} */
    ProductRemoveRequestModel.prototype._id;
    /** @type {?} */
    ProductRemoveRequestModel.prototype.cartId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/cart-product-list/cart-product-list.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CartProductListComponent {
    /**
     * @param {?} store
     * @param {?} cartLocalStorageService
     */
    constructor(store, cartLocalStorageService) {
        this.store = store;
        this.cartLocalStorageService = cartLocalStorageService;
        this.currentCartId = new EventEmitter();
        this.ChangeProductAmountFaild = false;
        this.ChangeProductAmountState$ = this.store.pipe(select(featureStatusOfOperationsOnCart));
    }
    /**
     * @param {?} product
     * @return {?}
     */
    deleteFromCart(product) {
        /** @type {?} */
        const request = new ProductRemoveRequestModel();
        request.productId = product.productId;
        request._id = product._id;
        request.cartId = this.getCartIdFromLocalStorage();
        this.store.dispatch(onRemoveProduct({ payload: request }));
        this.carts$ = this.store.pipe(select(featureCart));
        this.currentCartId.emit(this.getCartIdFromLocalStorage());
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.gtagRemoveFromCart(product);
        }), 1000);
    }
    /**
     * @param {?} amount
     * @param {?} product
     * @return {?}
     */
    onChangeAmount(amount, product) {
        this.store.dispatch(onChangeProductAmount({ payload: this.constructProductRequestUpdate(amount, product) }));
        this.checkChangeProductAmountSuccessfully(product);
        this.carts$ = this.store.pipe(select(featureCart));
        this.currentCartId.emit(this.getCartIdFromLocalStorage());
    }
    /**
     * @private
     * @param {?} amount
     * @param {?} product
     * @return {?}
     */
    constructProductRequestUpdate(amount, product) {
        /** @type {?} */
        const request = new ProductUpdateRequestModel();
        request.productId = product.productId;
        request._id = product._id;
        request.cartId = this.getCartIdFromLocalStorage();
        request.amount = amount;
        request.isPackagingSelected = product.isPackagingSelected;
        return request;
    }
    /**
     * @private
     * @return {?}
     */
    getCartIdFromLocalStorage() {
        return this.cartLocalStorageService.getCartId();
    }
    /**
     * @param {?} product
     * @return {?}
     */
    checkChangeProductAmountSuccessfully(product) {
        this.ChangeProductAmountState$.subscribe((/**
         * @param {?} status
         * @return {?}
         */
        (status) => {
            if (status === 'changeProductAmountFaild') {
                this.ChangeProductAmountFaild = true;
                this.productId = product.productId;
                this.currentProductPrice = product.price;
            }
            else if (status === '') {
                this.ChangeProductAmountFaild = false;
                this.productId = '';
                this.currentProductPrice = undefined;
            }
        }));
    }
    /**
     * @param {?} product
     * @return {?}
     */
    gtagRemoveFromCart(product) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            'event': 'EECremoveFromCart',
            'ecommerce': {
                'remove': {
                    'products': [{
                            'name': product.title,
                            'id': product.productId,
                            'price': product.price,
                            'category': product.category,
                            'quantity': product.amount,
                        }]
                }
            }
        });
    }
}
CartProductListComponent.decorators = [
    { type: Component, args: [{
                selector: 'lidl-lib-cart-fe-product-list',
                template: "<div class=\"cart-container\">\n  <div class=\"cart__header\">\n    <div class=\"cart__header--product-title\">\n      {{ \"modeso_cart_cart-product-list_table-col-product-title\" | injectedText | async }}</div>\n    <div class=\"cart__header--amount\">\n      {{ \"modeso_cart_cart-product-list_table-col-amount-title\" | injectedText | async }}</div>\n    <div class=\"cart__header--price\">{{ \"modeso_cart_cart-product-list_table-col-price-title\" | injectedText | async }}\n    </div>\n  </div>\n  <div *ngFor=\"let product of products\" class=\"cart\">\n    <div class=\"cart__body\">\n      <div class=\"cart__body--image\">\n        <img src={{product.image}} alt=\"{{product.title}}\">\n      </div>\n      <div class=\"cart__body--product-title\" id=\"productTitle\">{{product.title}}</div>\n      <div class=\"cart__body--description\">\n        <p class=\"cart__body--description\">{{ \"modeso_product_cart_description\" | injectedText | async }}: CHF {{product.price | number : '1.2'}}</p>\n      </div>\n      <div *ngIf=\"ChangeProductAmountFaild && product.productId === productId && product.price === currentProductPrice\" class=\"cart-limit-exceeded-error\">\n        {{ \"modeso_cart_add-to-cart_total_exceeded_error\" | injectedText | async }}\n      </div>\n      <modeso-counter class=\"cart__body--amount\" \n      [amount]=\"product.amount\" \n      [counterError]=\"(ChangeProductAmountFaild && product.productId === productId) ? true : false\"\n      (changeAmountEvent)=\"onChangeAmount($event, product)\"></modeso-counter>\n      <div class=\"cart__body--remove-products\" >\n        <a (click)=\"deleteFromCart(product)\">{{ \"modeso_cart_cart-product-list_remove-button-caption\" | injectedText | async }}</a>\n      </div>\n      <div class=\"cart__body--price\"> CHF\n        {{ (product.isPackagingSelected ? (product.amount * ( product.price + product.packagePrice )) :  ( product.amount * product.price )) | number : '1.2' }}\n      </div>\n    </div>\n  </div>\n</div>\n",
                styles: ["a{color:#000;cursor:pointer}.cart{border-bottom:1px solid #d4d1d4;padding-bottom:1em}.cart__header{border-bottom:1px solid #d4d1d4;font-weight:700;display:grid;gap:.6rem;grid-template-columns:repeat(12,1fr)}.cart__header--product-title{grid-column:1/7}.cart__header--amount{grid-column:8/10}.cart__header--price{grid-column:11/13}@media (max-width:991px){.cart__header--amount{display:none}.cart__header--price{grid-column:10/13}}.cart__body{padding:1em 0 0;display:grid;gap:.6rem;grid-template-columns:repeat(12,1fr);grid-template-areas:\"image image title title title title title amount amount rmproduct price price\" \"image image desc  desc  desc  desc  desc  amount amount rmproduct price price\" \"image image error error error error error amount amount rmproduct price price\"}.cart__body--product-title{-ms-grid-row:1;-ms-grid-column:5;-ms-grid-column-span:9;grid-area:title;font-size:clamp(1rem,4.1vw,1.5rem);font-weight:700}.cart__body--image{-ms-grid-row:1;-ms-grid-row-span:5;-ms-grid-column:1;-ms-grid-column-span:3;grid-area:image}.cart__body--image img{max-height:150px;-o-object-fit:contain;object-fit:contain}.cart__body--description{-ms-grid-row:3;-ms-grid-column:5;-ms-grid-column-span:9;grid-area:desc}.cart__body--amount{-ms-grid-row:1;-ms-grid-row-span:5;-ms-grid-column:15;-ms-grid-column-span:3;grid-area:amount;align-self:center}.cart__body--remove-products{-ms-grid-row:1;-ms-grid-row-span:5;-ms-grid-column:19;grid-area:rmproduct;align-self:center}.cart__body--price{-ms-grid-row:1;-ms-grid-row-span:5;-ms-grid-column:21;-ms-grid-column-span:3;grid-area:price;justify-self:right;align-self:center;font-size:clamp(.9rem,4.1vw,1rem)}.cart-limit-exceeded-error{-ms-grid-row:5;-ms-grid-column:5;-ms-grid-column-span:9;grid-area:error;color:red}@media (max-width:991px){.cart__body{grid-template-areas:\"title  title  title  title  title  title  title  title  price     price     price     price\" \"image  image  image  image  image  image  image  image  image     image     image     image\" \"error  error  error  error  error  error  error  error  error     error     error     error\" \"amount amount amount amount amount amount amount amount rmproduct rmproduct rmproduct rmproduct\"}.cart__body--description{display:none}.cart__body--product-title{-ms-grid-row:1;-ms-grid-column:1;-ms-grid-column-span:8}.cart__body--image{-ms-grid-row:2;-ms-grid-row-span:1;-ms-grid-column:1;-ms-grid-column-span:12}.cart__body--amount{-ms-grid-row:4;-ms-grid-row-span:1;-ms-grid-column:1;-ms-grid-column-span:8}.cart__body--remove-products{-ms-grid-row:4;-ms-grid-row-span:1;-ms-grid-column:9;-ms-grid-column-span:4}.cart__body--price{align-self:start;-ms-grid-row:1;-ms-grid-row-span:1;-ms-grid-column:9;-ms-grid-column-span:4}.cart-limit-exceeded-error{-ms-grid-row:3;-ms-grid-column:1;-ms-grid-column-span:12}}"]
            }] }
];
/** @nocollapse */
CartProductListComponent.ctorParameters = () => [
    { type: Store },
    { type: CartLocalStorageService }
];
CartProductListComponent.propDecorators = {
    products: [{ type: Input }],
    currentCartId: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    CartProductListComponent.prototype.carts$;
    /** @type {?} */
    CartProductListComponent.prototype.products;
    /** @type {?} */
    CartProductListComponent.prototype.currentCartId;
    /** @type {?} */
    CartProductListComponent.prototype.ChangeProductAmountFaild;
    /** @type {?} */
    CartProductListComponent.prototype.productId;
    /** @type {?} */
    CartProductListComponent.prototype.currentProductPrice;
    /** @type {?} */
    CartProductListComponent.prototype.ChangeProductAmountState$;
    /**
     * @type {?}
     * @private
     */
    CartProductListComponent.prototype.store;
    /**
     * @type {?}
     * @private
     */
    CartProductListComponent.prototype.cartLocalStorageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/modeso-counter/modeso-counter.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModesoCounterComponent {
    constructor() {
        this.currentAmount = 1;
        this.changeAmountEvent = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.currentAmount = this.amount;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        for (const propName in changes) {
            if (changes.hasOwnProperty(propName)) {
                switch (this.counterError) {
                    case true: {
                        this.currentAmount = this.maxAllowedAmount = this.amount;
                    }
                }
            }
        }
    }
    /**
     * @return {?}
     */
    increment() {
        this.currentAmount++;
        this.emitAmount(this.currentAmount);
        // this line fixes the amount when the error shows as it keeps it at the previous number before error
        this.currentAmount--;
    }
    /**
     * @return {?}
     */
    decrement() {
        if (this.currentAmount > 1) {
            this.currentAmount--;
            this.emitAmount(this.currentAmount);
        }
    }
    /**
     * @return {?}
     */
    checkValue() {
        if (this.counterError) {
            this.currentAmount = this.maxAllowedAmount;
        }
        else {
            this.currentAmount = +this.currentAmount < 1 ? 1 : +this.currentAmount;
            this.emitAmount(this.currentAmount);
        }
    }
    /**
     * @private
     * @param {?} amount
     * @return {?}
     */
    emitAmount(amount) {
        this.changeAmountEvent.emit(amount);
    }
}
ModesoCounterComponent.decorators = [
    { type: Component, args: [{
                selector: 'modeso-counter',
                template: "<div class=\"input-group\">\n  <input type=\"button\" value=\"-\" class=\"button-minus\" (click)=\"decrement()\">\n  <input type=\"text\" onkeypress=\"return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57\"\n    name=\"amount\" [(ngModel)]=\"currentAmount\" (change)=\"checkValue()\" class=\"quantity-field\"\n    [ngClass]=\"{'amount-error': counterError}\">\n  <input type=\"button\" value=\"+\" class=\"button-plus\" (click)=\"increment()\" \n  >\n</div>\n",
                styles: ["input,textarea{border:1px solid #eee;box-sizing:border-box;margin:0;outline:0;padding:10px}input[type=button]{-webkit-appearance:button;cursor:pointer}input::-webkit-inner-spin-button,input::-webkit-outer-spin-button{-webkit-appearance:none}.input-group{display:table;width:initial;margin:0;position:relative;border:1px solid #bdbbbd}.input-group input[type=button]{background-color:#fff;min-width:2em;width:auto;transition:.3s}.input-group .button-minus,.input-group .button-plus{font-weight:700;height:2.5em;padding:0;width:2em;position:relative}.input-group .quantity-field{position:relative;height:2.5em;text-align:center;width:3em;display:inline-block;font-size:13px;margin:0;resize:vertical;border:0}.amount-error{opacity:.7}"]
            }] }
];
/** @nocollapse */
ModesoCounterComponent.ctorParameters = () => [];
ModesoCounterComponent.propDecorators = {
    counterError: [{ type: Input }],
    amount: [{ type: Input }],
    changeAmountEvent: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    ModesoCounterComponent.prototype.counterError;
    /** @type {?} */
    ModesoCounterComponent.prototype.amount;
    /** @type {?} */
    ModesoCounterComponent.prototype.changeAmountEvent;
    /** @type {?} */
    ModesoCounterComponent.prototype.currentAmount;
    /** @type {?} */
    ModesoCounterComponent.prototype.maxAllowedAmount;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/cart-total/cart-total.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CartTotalComponent {
    constructor() { }
    /**
     * @return {?}
     */
    getTotalPrice() {
        if (this.additionalCharges === undefined || this.additionalCharges === null) {
            return +this.cartTotalPrice;
        }
        else {
            return +this.cartTotalPrice + +this.additionalCharges;
        }
    }
}
CartTotalComponent.decorators = [
    { type: Component, args: [{
                selector: 'cart-total-option',
                template: "<div class=\"total-price\">\n  <div>\n    <div class=\"total-title\">\n      {{ \"modeso_cart_cart_cart-total_summary-total-sum\" | injectedText | async }}\n    </div>\n    <div class=\"total-desc\">\n      {{ \"modeso_cart_cart_cart-total_summary-total-vat\" | injectedText | async }}\n    </div>\n  </div>\n  <div id=\"cartTotalPrice\" class=\"total-price\">CHF {{getTotalPrice() | number : '1.2'}}</div>\n</div>",
                styles: [".total-price{display:flex}.total-price .total-title{font-weight:700}.total-price .total-desc{font-weight:400}.total-price .total-price{margin:auto 0 auto auto;font-size:1.3rem;font-weight:700}"]
            }] }
];
/** @nocollapse */
CartTotalComponent.ctorParameters = () => [];
CartTotalComponent.propDecorators = {
    cartTotalPrice: [{ type: Input }],
    additionalCharges: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    CartTotalComponent.prototype.cartTotalPrice;
    /** @type {?} */
    CartTotalComponent.prototype.additionalCharges;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/compact-cart/compact-cart.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CompactCartComponent {
    /**
     * @param {?} store
     * @param {?} cartLocalStorageService
     */
    constructor(store, cartLocalStorageService) {
        this.store = store;
        this.cartLocalStorageService = cartLocalStorageService;
        this.cartVisible = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.cartLocalStorageService.isSetCartId()) {
            this.store.dispatch(onLoadCart());
        }
        this.carts$ = this.store.pipe(select(featureCart));
    }
    /**
     * @param {?} event
     * @return {?}
     */
    toggleResponsiveCartView(event) {
        this.cartVisible = !this.cartVisible;
        event.stopPropagation();
    }
}
CompactCartComponent.decorators = [
    { type: Component, args: [{
                selector: 'modeso-compact-cart',
                template: "<div class=\"responsive-background\" [attr.data-cart-visible]=\"cartVisible\" (click)=\"toggleResponsiveCartView($event)\">\n  <div class=\"compact-cart product-card-list-container table-responsive\">\n    <table class=\"table product-card-list\">\n      <thead>\n        <tr>\n          <th>{{ \"modeso_cart_compact-cart_title\" | injectedText | async }}</th>\n          <th><button class=\"ml-auto close-button\" (click)=\"toggleResponsiveCartView($event)\">&times;</button></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr *ngFor=\"let product of (carts$ | async)?.cart?.products\">\n          <td>\n            <div class=\"product-container\">\n              <div class=\"image-container\">\n                <img id=\"productImg\" src={{product.image}} alt=\"product-alt\">\n              </div>\n              <div class=\"product-details\">\n                <span id=\"productTitle\" class=\"product-title\">{{product.title}}</span>\n                <!-- \n                  leaving this as we might need packaging in future\n                  \n                <p id=\"productDescription\" class=\"product-desc\">\n                  {{ product.isPackagingSelected ? 'Geschenkverpackung' : 'Keine Verpackung' }}</p>\n                -->\n                <p id=\"productAmount\" class=\"product-desc\"> {{ product.amount }}x</p>\n              </div>\n            </div>\n          </td>\n          <td id=\"productPrice\" class=\"price\"> CHF\n            {{ product.isPackagingSelected ? ( (product.amount * ( product.price + product.packagePrice ) | number : '1.2'))  :  ( product.amount * product.price) | number : '1.2' }}\n          </td>\n        </tr>\n        <!-- TODO refactor to not be a table -->\n        <ng-content select=\"[afterProductList]\"></ng-content>\n        <tr>\n          <td colspan=\"2\">\n            <cart-total-option \n            [cartTotalPrice]='(carts$ | async)?.totalPrice'\n            [additionalCharges]='additionalCharges'\n            >\n            </cart-total-option>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n<div class=\"responsive-action-footer\">\n  <div class=\"responsive-mobile\">\n    <cart-total-option\n      [cartTotalPrice]='(carts$ | async)?.totalPrice'\n      [additionalCharges]='additionalCharges'>\n    </cart-total-option>\n  </div>\n  <div class=\"action-buttons\">\n    <div class=\"responsive-mobile\">\n      <button class=\"btn-cta btn-cta-secondary summary-button\" (click)=\"toggleResponsiveCartView($event)\">\n        {{ \"modeso_summary_button\" | injectedText | async }}\n      </button>\n    </div>\n    <ng-content select=\"[afterTotal]\"></ng-content>\n  </div>\n</div>",
                styles: [".close-button,.responsive-mobile{display:none}@media (max-width:991px){.responsive-background{display:none;position:fixed;top:0;bottom:0;left:0;right:0;z-index:99998;background-color:rgba(0,0,0,.8)}.compact-cart{position:fixed;top:0;right:0;bottom:0;width:100%;max-width:400px;z-index:99999;background-color:#fff;padding:1em}.responsive-background[data-cart-visible=true]{display:block}.responsive-action-footer{display:block;position:fixed;left:0;bottom:0;right:0;background-color:#fff;box-shadow:0 -2px 4px 0 rgba(0,0,0,.15);z-index:9999;padding:1em}.responsive-mobile{display:block}.action-buttons{display:flex;justify-content:flex-end;gap:1em;width:100%;margin-top:1em}.summary-button{max-width:265px;width:100%}}@media (max-width:991px) and (max-width:576px){.action-buttons{flex-direction:column-reverse;align-items:center}}@media (max-width:991px){.close-button{display:block;color:#00438f;background-color:transparent;border:0;font-size:1.3rem}}.compact-cart::ng-deep .product-card-list th{font-weight:700;font-size:16px;padding-left:0}.compact-cart::ng-deep .product-card-list td{vertical-align:top;padding:30px 0;font-size:16px}.compact-cart::ng-deep .product-card-list .product-container{display:table}.compact-cart::ng-deep .product-card-list .product-container .image-container{width:115px;float:left;margin-right:30px}.compact-cart::ng-deep .product-card-list .product-container .image-container img{width:100%}.compact-cart::ng-deep .product-card-list .product-container .product-details{margin-right:118px;display:table-cell;vertical-align:top;font-size:14px}.compact-cart::ng-deep .product-card-list .product-container .product-details .product-title{font-size:16px;font-weight:700}.compact-cart::ng-deep .product-card-list .price{text-align:right;padding-right:10px}.compact-cart::ng-deep .product-card-list .shipping-title{font-weight:700}"]
            }] }
];
/** @nocollapse */
CompactCartComponent.ctorParameters = () => [
    { type: Store },
    { type: CartLocalStorageService }
];
CompactCartComponent.propDecorators = {
    additionalCharges: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    CompactCartComponent.prototype.additionalCharges;
    /** @type {?} */
    CompactCartComponent.prototype.cartVisible;
    /** @type {?} */
    CompactCartComponent.prototype.carts$;
    /**
     * @type {?}
     * @private
     */
    CompactCartComponent.prototype.store;
    /**
     * @type {?}
     * @private
     */
    CompactCartComponent.prototype.cartLocalStorageService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/refreshCart/refresh-cart-store.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RefreshCartStoreComponent {
    /**
     * @param {?} store
     */
    constructor(store) {
        this.store = store;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.store.dispatch(addNewCart());
    }
}
RefreshCartStoreComponent.decorators = [
    { type: Component, args: [{
                selector: 'modeso-refresh-cart-store',
                template: "\n",
                styles: [""]
            }] }
];
/** @nocollapse */
RefreshCartStoreComponent.ctorParameters = () => [
    { type: Store }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    RefreshCartStoreComponent.prototype.store;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/cart.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Cart {
    /**
     * @param {?=} init
     */
    constructor(init) {
    }
}
if (false) {
    /** @type {?} */
    Cart.prototype._id;
    /** @type {?} */
    Cart.prototype.userId;
    /** @type {?} */
    Cart.prototype.products;
    /** @type {?} */
    Cart.prototype.deliveryOptions;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/compact-cart-view/compact-cart-view.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CompactCartViewComponent {
    constructor() { }
}
CompactCartViewComponent.decorators = [
    { type: Component, args: [{
                selector: 'modeso-compact-cart-view',
                template: "<div class=\"compact-cart product-card-list-container table-responsive\">\n  <table class=\"table product-card-list\">\n    <thead>\n      <tr>\n        <th colspan=\"3\">{{ \"modeso_cart_compact-cart_title\" | injectedText | async }}</th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr *ngFor=\"let product of cart?.products\">\n        <td>\n          <div class=\"product-container\">\n            <div class=\"image-container\">\n              <img id=\"productImg\" src={{product.image}} alt=\"product-alt\">\n            </div>\n            <div class=\"product-details\">\n              <span id=\"productTitle\" class=\"product-title\">{{product.title}}</span>\n              <!-- \n                we might want to bring back packaging options, so leaving this in\n              <p id=\"productDescription\" class=\"product-desc\">\n                {{ product.isPackagingSelected ? 'Geschenkverpackung' : 'Keine Verpackung' }}</p>\n              -->\n              <p id=\"productAmount\" class=\"product-desc\"> {{ product.amount }}x</p>\n            </div>\n          </div>\n        </td>\n        <td id=\"productPrice\" class=\"price\"> CHF\n          {{ product.isPackagingSelected ? ( (product.amount * ( product.price + product.packagePrice ) | number : '1.2'))  :  ( product.amount * product.price) | number : '1.2' }}\n        </td>\n      </tr>\n      <!-- TODO refactor to not be a table -->\n      <ng-content select=\"[afterProductList]\"></ng-content>\n      <tr>\n        <td colspan=\"2\">\n          <cart-total-option \n          [cartTotalPrice]='totalPrice'\n          [additionalCharges]='additionalCharges'\n          >\n          </cart-total-option>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n",
                styles: [".compact-cart::ng-deep .product-card-list th{font-weight:700;font-size:16px;padding-left:0}.compact-cart::ng-deep .product-card-list td{vertical-align:top;padding:30px 0;font-size:16px}.compact-cart::ng-deep .product-card-list .product-container{display:table}.compact-cart::ng-deep .product-card-list .product-container .image-container{width:115px;float:left;margin-right:30px}.compact-cart::ng-deep .product-card-list .product-container .image-container img{width:100%}.compact-cart::ng-deep .product-card-list .product-container .product-details{margin-right:118px;display:table-cell;vertical-align:top;font-size:14px}.compact-cart::ng-deep .product-card-list .product-container .product-details .product-title{font-size:16px;font-weight:700}.compact-cart::ng-deep .product-card-list .price{text-align:right;padding-right:10px}.compact-cart::ng-deep .product-card-list .shipping-title{font-weight:700}"]
            }] }
];
/** @nocollapse */
CompactCartViewComponent.ctorParameters = () => [];
CompactCartViewComponent.propDecorators = {
    additionalCharges: [{ type: Input }],
    cart: [{ type: Input }],
    totalPrice: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    CompactCartViewComponent.prototype.additionalCharges;
    /** @type {?} */
    CompactCartViewComponent.prototype.cart;
    /** @type {?} */
    CompactCartViewComponent.prototype.totalPrice;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/cart.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModesoCartModule {
    /**
     * @param {?} config
     * @return {?}
     */
    static forRoot(config) {
        return {
            ngModule: ModesoCartModule,
            providers: [
                CartService,
                {
                    provide: ModesoCartConfigService,
                    useValue: config
                }
            ]
        };
    }
}
ModesoCartModule.decorators = [
    { type: NgModule, args: [{
                declarations: [AddToCartComponent, CartIconComponent, CompactCartComponent,
                    ProductPackageComponent, CartComponent, CartProductListComponent,
                    ModesoCounterComponent, CartTotalComponent, RefreshCartStoreComponent,
                    CompactCartViewComponent],
                providers: [CartService, DatePipe],
                imports: [
                    CommonModule,
                    FormsModule,
                    InjectedTextFeautureModule,
                    StoreModule.forFeature(cartFeatureKey, reducer),
                    EffectsModule.forFeature([CartEffect]),
                ],
                exports: [AddToCartComponent, CartIconComponent, ProductPackageComponent, CartComponent,
                    ModesoCounterComponent, CartTotalComponent, CompactCartComponent, RefreshCartStoreComponent,
                    CompactCartViewComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/request/add-delivery-to-cart-request.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AddDeliveryToCartRequest {
}
if (false) {
    /** @type {?} */
    AddDeliveryToCartRequest.prototype.key;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/provider/cartStore.provider.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug$1 = Debug('modeso:lidl-lib-cart-fe:CartStoreProvider');
/** @type {?} */
const strings = [
    { 'modeso_cart_add-to-cart-button_caption': 'In den Warenkorb' },
    { 'modeso_cart_cart-icon-label': 'Warenkorb' },
    { 'modeso_cart_cart_empty': 'There are no Products In Cart' },
    { 'modeso_cart_cart-product-list_table-col-product-title': 'Artikel' },
    { 'modeso_cart_cart-product-list_table-col-amount-title': 'Menge' },
    { 'modeso_cart_cart-product-list_table-col-price-title': 'Preis' },
    { 'modeso_cart_cart-product-list_remove-button-caption': 'Entfernen' },
    { 'modeso_cart_cart_cart-total_summary-total-sum': 'Gesamtsumme' },
    { 'modeso_cart_cart_cart-total_summary-total-vat': 'inkl. MwSt. und Versand' },
    { 'modeso_cart_compact-cart_title': 'Ihre Bestellung' },
];
class CartStoreProvider {
    /**
     * @param {?} store
     * @param {?} injectedTextProvider
     */
    constructor(store, injectedTextProvider) {
        this.store = store;
        this.injectedTextProvider = injectedTextProvider;
        /** @type {?} */
        const defaultStrings = new Array();
        strings.forEach((/**
         * @param {?} element
         * @return {?}
         */
        (element) => {
            /** @type {?} */
            const x = new NamedString(Object.keys(element)[0], element[Object.keys(element)[0]]);
            defaultStrings.push(x);
        }));
        debug$1('set default text');
        this.setInjectedText(defaultStrings);
    }
    /**
     * @return {?}
     */
    addNewCart() {
        this.store.dispatch(addNewCart());
    }
    /**
     * @return {?}
     */
    getActiveCart$() {
        return this.store.pipe(select(featureCart), map((/**
         * @param {?} cartResponse
         * @return {?}
         */
        (cartResponse) => {
            return cartResponse.cart;
        })));
    }
    /**
     * @return {?}
     */
    getActiveCartTotal$() {
        return this.store.pipe(select(featureCart), map((/**
         * @param {?} cartResponse
         * @return {?}
         */
        (cartResponse) => {
            return cartResponse.totalPrice;
        })));
    }
    /**
     * @return {?}
     */
    getDeliveryOptions$() {
        return this.store.pipe(select(featureDeliveryOptionsOfCart), filter((/**
         * @param {?} deliveryOptions
         * @return {?}
         */
        (deliveryOptions) => deliveryOptions != null)));
    }
    /**
     * @return {?}
     */
    loadCart() {
        this.store.dispatch(onLoadCart());
    }
    /**
     * @param {?} deliveryOptionToBeAdded
     * @return {?}
     */
    addSelectedDeliveryOption$(deliveryOptionToBeAdded) {
        this.store.dispatch(addSelectedDeliveryOption({ payload: deliveryOptionToBeAdded }));
    }
    /**
     * @private
     * @param {?} injectedText
     * @return {?}
     */
    setInjectedText(injectedText) {
        this.injectedTextProvider.setInjectedText(injectedText);
    }
}
CartStoreProvider.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
CartStoreProvider.ctorParameters = () => [
    { type: Store },
    { type: InjectedTextProvider }
];
/** @nocollapse */ CartStoreProvider.ngInjectableDef = ɵɵdefineInjectable({ factory: function CartStoreProvider_Factory() { return new CartStoreProvider(ɵɵinject(Store), ɵɵinject(InjectedTextProvider)); }, token: CartStoreProvider, providedIn: "root" });
if (false) {
    /** @type {?} */
    CartStoreProvider.prototype.store;
    /**
     * @type {?}
     * @private
     */
    CartStoreProvider.prototype.injectedTextProvider;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/product-notification.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProductNotificationModel {
}
if (false) {
    /** @type {?} */
    ProductNotificationModel.prototype.isError;
    /** @type {?} */
    ProductNotificationModel.prototype.message;
    /** @type {?} */
    ProductNotificationModel.prototype.productId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: modeso-giftcardshop-lib-cart-fe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AddDeliveryToCartRequest, Cart, CartProductModel, CartStoreProvider, ModesoCartConfigService, ModesoCartModule, ProductNotificationModel, AddToCartComponent as ɵa, cartFeatureKey as ɵb, onChangeProductAmountSuccess as ɵba, onChangeProductAmountFail as ɵbb, onLoadCart as ɵbc, onLoadCartSuccess as ɵbd, onChangeCardDeliveryOptions as ɵbe, addNewCart as ɵbf, onNewToCartSuccess as ɵbg, addSelectedDeliveryOption as ɵbh, onAddSelectedDeliveryOptionSuccessfully as ɵbi, onAddSelectedDeliveryOptionFailed as ɵbj, CartEffect as ɵbk, initialState as ɵd, reducer as ɵe, CartLocalStorageService as ɵf, CartIconComponent as ɵg, CompactCartComponent as ɵh, ProductPackageComponent as ɵi, CartComponent as ɵj, CartProductListComponent as ɵk, ModesoCounterComponent as ɵl, CartTotalComponent as ɵm, RefreshCartStoreComponent as ɵn, CompactCartViewComponent as ɵo, CartService as ɵp, CartResponseModel as ɵq, DeliveryOptionModel as ɵr, addToCart as ɵs, onAddToCartSuccess as ɵt, onAddToCartFail as ɵu, onChangeProductPackage as ɵv, onRemoveProduct as ɵw, onRemoveProductSuccess as ɵx, onChangeProductPackageSuccess as ɵy, onChangeProductAmount as ɵz };
